import { Text } from "../../design-system";
import React from "react";
import News from "../News/News";
import Music from "../Music/Music";
import Shows from "../Shows/Shows";
import { Header, Footer } from "../../components";

function Home() {
  return (
    <div className="overflow-clip bg-[radial-gradient(circle_at_50%_22%,rgb(var(--color-glow))_0,rgb(var(--color-background))_35%)]">
      <Header />
      <main className="mx-auto w-[min(1280px,calc(100%-48px))] pb-[92px] pt-12 max-[640px]:w-[calc(100%-32px)] max-[640px]:pb-16 max-[640px]:pt-[34px]" id="content">
        {/* <div className="flex items-center justify-between gap-[25px] border-b border-border pb-[38px] max-[640px]:block max-[640px]:pb-[25px] [&_p]:m-0 [&_p]:text-[13px] [&_p]:tracking-[.03em] [&_p]:text-intro max-[640px]:[&_p]:mt-3 max-[640px]:[&_p]:leading-normal">
          <Text variant="eyebrow">THE UNDERGROUND LIVES ON</Text>
          <p>Death metal from São Paulo, Brazil. Loud, raw, and uncompromising.</p>
        </div> */}
        <div className="grid grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] gap-[clamp(26px,4vw,64px)] pt-14 max-[900px]:grid-cols-1 max-[640px]:gap-[54px] max-[640px]:pt-[38px]">
          <div className="min-w-0" id="news"><News /></div>
          <aside className="flex min-w-0 flex-col gap-[60px] max-[900px]:gap-[54px] [&>div]:min-w-0">
            <div id="shows"><Shows /></div>
            <div id="music"><Music /></div>
          </aside>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Home;
